<template>
  <main class="container-fluid flex-grow-1 d-flex bg-lighter">
    <div class="row flex-grow-1">
      <slot v-if="$slots.sidebar" name="sidebar" />
      <navbar v-else />

      <div class="col px-4 tab-layout__col">
        <breadcrumb />

        <div :class="fullWidth ? 'w-100 px-0' : 'container container-full-mob ml-0 px-0'">
          
          <ul class="nav nav-tabs col-md-11 px-0" id="myTab" role="tablist">
            <slot name="tabHeading"></slot>
          </ul>

          <slot name="tabContent"></slot>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/* This is a consistent layout that should be used for listing pages.
 * Content will be added to the "slot" tags above automagically when
 * this component is added */

import navbar from '@/components/NavbarSide'
import breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'Tab-Layout',
  components: {
    navbar,
    breadcrumb
  },
  props: {
    fullWidth: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.tab-layout__col {
  // Bootstrap 4's .col has no min-width: 0, so wide unbreakable content
  // (e.g. tables) can stretch this flex item past the viewport width.
  min-width: 0;
}

.container-full-mob {

  @media (max-width: 1399px) {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TabLayout.vue